export default __webpack_public_path__ + "static/media/grd_icon.82020586.svg";